module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-italic-48b3875d087f3cd91ad72704363b93f1.png";